import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import { AdProviders, adunitMemo, ADUNIT_MAP } from '../../../constants';
import { useAdUnit } from '../../../useAdUnit';
const DesktopDevPageSide300x250 = /*#__PURE__*/ React.memo(({ safety = 'off', safetyState })=>{
    const _useAdUnit = useAdUnit(AdProviders.Freestar, ADUNIT_MAP['DesktopDevPageSide300x250Gam'], safety, safetyState, {
        targeting: {
            unitType: 'btf'
        }
    }), { advertIsOff } = _useAdUnit, slotAttr = _object_without_properties(_useAdUnit, [
        "advertIsOff"
    ]);
    if (advertIsOff === 'off') {
        return null;
    }
    return /*#__PURE__*/ React.createElement("div", slotAttr);
}, adunitMemo);
DesktopDevPageSide300x250.displayName = 'DesktopDevPageSide300x250';
export default DesktopDevPageSide300x250;
